export const REQUEST_STATUS = {
    SUCCESS: "success",
    ERROR: "erreur",
};